import { layout } from '../../App.routing'

export const latestEditionSegment = layout.component({
    type: 'nightly-latest-edition',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 1,
            publication: 'the_nightly',
        },
        title: 'Latest Edition',
        type: 'homepage',
        lazyloadImages: true,
    },
})

export const previousEditionsSegment = layout.component({
    type: 'nightly-previous-editions',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 5,
            publication: 'the_nightly',
        },
        title: 'All Editions',
        type: 'homepage',
        lazyloadImages: true,
    },
})

export const travelEditionSegment = layout.component({
    type: 'nightly-special-edition-home',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 1,
            publication: 'the_nightly_travel',
        },
        publicationTitle: 'By The Nightly',
        lazyloadImages: true,
        isTravelEdition: true,
        heading: 'Roam',
        showFirstDivider: false,
    },
})

export const specialEditionSegment = layout.component({
    type: 'nightly-special-edition-home',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 1,
            publication: 'the_nightly_on',
        },
        lazyloadImages: true,
        publicationTitle: 'By The Nightly',
    },
})
